import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { TableCell, TableRow } from '@mui/material';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { Edit } from '@mui/icons-material';
import { ThinCheckbox } from 'components/common/Styles';
import { ADMIN_INSURANCE_CONVENTIONS_READ } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const InsuranceConventionComponent = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const canRead = usePermission(ADMIN_INSURANCE_CONVENTIONS_READ);

  const navigateToInsuranceConvention = useCallback(() => {
    historyContext.push(`/insuranceConventions/${data.productId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>
        <Typography title={data.productCode}>{data.productCode}</Typography>
      </TableCell>
      <TableCell>
        <Typography title={data.productName}>{data.productName}</Typography>
      </TableCell>
      <TableCell align='center'>
        <ThinCheckbox checked={data.isActive} disabled />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          color='primary'
          variant='text'
          size='small'
          tooltip={t('InsuranceConventions.Edit')}
          onClick={navigateToInsuranceConvention}
          disabled={!canRead}
        >
          <Edit fontSize='small' />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

InsuranceConventionComponent.propTypes = {
  data: PropTypes.object
};

export default InsuranceConventionComponent;
